module.exports = __webpack_public_path__ + "img/top.74ee2e67.png";